import { theme } from '../../../themes/main';
import { SxStyles } from '../../../types';

export const styles: SxStyles = {
  title: {
    px: { xs: 5, lg: 6 },
    mb: { xs: 5, lg: 8 },
  },
  hitButton: {
    mt: { xs: 4, md: 0 },
    px: { xs: 5, md: 0 },
    '& .MuiButton-root': {
      px: 5,
    },
  },
  estateSearchSelectBox: {
    width: {
      sm: `calc(150px + ${theme.spacing(3)} / 2)`,
    },
    display: 'flex',
  },
  alignItemsStretch: {
    alignItems: 'stretch',
  },
};
